import {
  CREATE_PLC_SAFETY_TRIGGER,
  CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  CREATE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

const initialState = {
  createPlcSafetyTriggerError: null,
  messagePlcSafetyTrigger: null,
  loadingCreatePlcSafetyTrigger: false,
};

const createTrigger = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PLC_SAFETY_TRIGGER:
      state = { ...state, loadingCreatePlcSafetyTrigger: true, createPlcSafetyTriggerError: null };
      break;
    case CREATE_PLC_SAFETY_TRIGGER_SUCCESSFUL:
      state = {
        ...state,
        loadingCreatePlcSafetyTrigger: false,
        messagePlcSafetyTrigger: action.payload,
        createPlcSafetyTriggerError: null,
      };
      break;
    case CREATE_PLC_SAFETY_TRIGGER_FAILED:
      state = {
        ...state,
        messagePlcSafetyTrigger: null,
        loadingCreatePlcSafetyTrigger: false,
        createPlcSafetyTriggerError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createTrigger;
